export const PARTICIPANTS_TEXT = {
    id: 'oe.common.participants',
    defaultMessage: 'Participants',
    description: 'Label text'
};